// extracted by mini-css-extract-plugin
export default {"collapseIcon":"Row_collapseIcon__Q9CZW","menuItemIcon":"Row_menuItemIcon__0XpfS"};